if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');
        this.upsellOverlay = document.querySelector('upsell-overlay');
        this.upsellDrawer = document.querySelector('upsell-drawer');

        this.mobileScreenSize = 1140; // Set the screen size threshold

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      const quantityBreakerEl = document.getElementById('quanity_breaker');
      const checkedRadio = quantityBreakerEl ? quantityBreakerEl.querySelector('input[type="radio"]:checked') : null;
      const quantity = checkedRadio ? parseInt(checkedRadio.value) : 1;

      // Get compare at price
      const compareAtPrice = this.form.querySelector('[data-compare-at-price]')?.dataset.compareAtPrice || 
                            this.querySelector('[data-compare-at-price]')?.dataset.compareAtPrice ||
                            this.dataset.compareAtPrice;

      // Build items array
      let items = [];
      const mainItem = { 
        id: this.form.querySelector('[name="id"]').value, 
        quantity: quantity 
      };

      // Add compare at price as line item property (simpler approach)
      if (compareAtPrice && parseFloat(compareAtPrice) > 0) {
        mainItem.properties = {
          '_compare_at_price': compareAtPrice
        };
      }

      items.push(mainItem);

      const freeProductId = this.submitBtn.getAttribute('data-free-id');
      if (freeProductId) {
        items.push({ id: freeProductId, quantity: quantity });
      }

      const isMobile = window.innerWidth < 1140;

      // const isCartIcon = opener && opener.id === 'cart-icon';   

      // If desktop and upsell overlay is enabled, show that instead when the cart is open
      if (!isMobile && this.upsellOverlay) {
        // Determine if the current context has upsell products
        // const openerHasUpsell = opener?.dataset?.hasUpsellProducts === 'true';
        const pageHasUpsell = this.submitBtn.getAttribute('data-has-upsell-products') === 'true';
        console.log('pageHasUpsell', pageHasUpsell);


        if (pageHasUpsell) {
          // Wait for the cart drawer to open before opening the upsell overlay
          setTimeout(() => {
            this.upsellOverlay.open();
          }, 0); // Adjust delay as needed for animation timing
        } else {
          // Fallback to regular cart drawer when no upsell recommendations exist
          // this.overlay.classList.add('is-visible');
        }

      // if (!isMobile && this.upsellOverlay && !isCartIcon) {
      }

      

      // Simplified cart attributes - only add if really needed
      // let cartAttributes = {};
      // if (compareAtPrice && parseFloat(compareAtPrice) > 0) {
      //   const variantId = this.form.querySelector('[name="id"]').value;
      //   // Simple approach - just store the last added variant's compare at price
      //   cartAttributes = {
      //     '_last_variant_compare_at_price': `${variantId}:${compareAtPrice}`
      //   };
      // }

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items,
          sections: sections,
          sections_url: window.location.pathname,
          // attributes: cartAttributes
        })
      };

      try {
        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        const error = typeof data.description === 'string' ? data.description : data.message;

        if (data.status) this.setErrorMsgState(error);

        if (error !== 'La quantité demandée est indisponible') {
          if (!response.ok) throw new Error(response.status);
        } else {
          const cartItems = document.querySelector('cart-items');
          if (cartItems) cartItems.refresh();
        }

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon immediately with response data
          ProductForm.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          // Render cart drawer immediately with response data (no additional fetch needed)
          // Removed setTimeout to prevent flicker between drawer transitions
          if (this.cartDrawer) {
              const isMobile = window.innerWidth < this.mobileScreenSize;

              if ((this.upsellOverlay || this.upsellDrawer) && isMobile) {
                if (quickAddDrawer) {
                  // Get hasUpsellProducts from the submit button, not the product-form
                  const hasUpsellProducts = this.submitBtn?.getAttribute('data-has-upsell-products') === 'true';
                  
                  // Close the drawer while keeping overflow hidden to prevent flicker during transition
                  // The upsell/cart drawer will inherit the scroll lock and overlay
                  quickAddDrawer.close(null, true);
                  
                  const upsellEvent = new CustomEvent('open-upsell-drawer', {
                    detail: {
                      hasUpsellProducts: hasUpsellProducts
                    }
                  });
                  document.dispatchEvent(upsellEvent);

                  this.cartDrawer.renderContents(data, false);
                } else {
                  // Main product page - upsell-drawer.liquid handles the event dispatch
                  // Just render cart contents without opening (upsell drawer will handle opening)
                  this.cartDrawer.renderContents(data, false);
                }
              } else if (this.upsellOverlay && !isMobile) {
                this.cartDrawer.renderContents(data, theme.settings.afterAtc === 'drawer');
              }

              if (!this.upsellOverlay && !this.upsellDrawer) {
                this.cartDrawer.renderContents(data, theme.settings.afterAtc === 'drawer');
              }
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                cartItems.refresh();
              }
            }
          }
        }

        // Set localStorage (keep this)
        if (!data.status && !error) {
          const productHandle = this.dataset.productHandle;
          if (productHandle) {
            localStorage.setItem('lastAddedProduct', JSON.stringify({
              product_id: data.items[0].product_id,
              handle: productHandle,
              price: data.items[0].price
            }));
          }
        }

        // Fire events with response data instead of fetching again
        this.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: {
            cart: data, // Use response data instead of fetching
            variantId: data.variant_id || mainItem.id
          }
        }));

      } catch (error) {
        console.log(error);
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent || 'Add to cart failed'
          }
        }));
      } finally {
        // Re-enable button
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        
        if (this.upsellOverlay) {
          const isTriggeredFromOverlay = evt.srcElement.closest('.upsell');
          if (isTriggeredFromOverlay) {
            this.upsellAnimate(evt);
          }
        }

        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 50);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }

    upsellAnimate(evt) {
      // evt.preventDefault();
      const srcEl = evt.srcElement;
  
      // Get the elements
      const button = srcEl.querySelector('button[type="submit"]');
      console.log('button', button);

      const addToCartText = button.querySelector('.upsell__add-to-cart-text');
      const confirmationText = button.querySelector('.upsell__added-confirmation');
  
      if (addToCartText && confirmationText) {
        // Slide up the add to cart text
        addToCartText.style.transform = "translateY(-200%)";
  
        // Slide down the confirmation text
        confirmationText.style.transform = "translateY(-50%)";
        confirmationText.style.top = "50%";
  
        // After 2 seconds, revert the changes
        setTimeout(() => {
          addToCartText.style.transform = "translateY(-50%)";
          confirmationText.style.transform = "translateY(200%)";
        }, 2000);
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
